{
	"backToManageDeclarations": "Tilbake til Administrer erklæringer"
}
